import React, {useEffect, lazy} from 'react';
import { ConfigProvider, theme, message, Select } from 'antd';
import { BrowserRouter, Route } from 'react-router-dom';
import zhCN from 'antd/lib/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
const Router = lazy(() => import('./Router'))
// import Router from './Router';
import { useUserStore } from '@/store/theme';
import './index.css';
// import 'antd/dist/antd.min.css';
import { WebSocketProvider } from '@/const/webSocket'
moment.locale('zh-cn');
// message.config({
//   prefixCls: 'custom-message',
//   duration: 10000
// });

import {
    getSettlementDay
} from '@/services/api/DerivativeInstrumentsService';

const App = () => {
    const themeStr = useUserStore((state) => state.theme);

    useEffect(() => {
      document.documentElement.setAttribute('data-theme', themeStr || 'dark');
      if (!localStorage.getItem('theme')) {
        localStorage.setItem('theme', 'dark')
      }
    }, [themeStr]);

    // useEffect(() => {
    //     searchBusinessDay()
    // }, []);

     // 查询业务日期
     const searchBusinessDay = () => {
        getSettlementDay().then((res) => {
            if (res && res.code == 200) {
                sessionStorage.setItem('systemBusinessDate', res.data);
            }
        });
    };

    return (
        <ConfigProvider
            locale={zhCN}
            theme={{
              algorithm: theme.darkAlgorithm
            }}
        >
            <BrowserRouter>
                <WebSocketProvider>
                  <Router />
                </WebSocketProvider>
            </BrowserRouter>
        </ConfigProvider>
    );
};

export default App;
